import { createSlice } from '@reduxjs/toolkit';

const dialogState = {
	note: false,
	proposal: false,
	contact: false,
	task: false,
	summary: false,
	quote: false,
	wytu: false,
	completeDeal: false,
	debtorAutomationContact: false,
	editPolicyTransaction: false,
	createFolder: false,
	createComplianceStep: false,
	moveFile: false,
	fileExists: false,
	renameFile: false,
	selectDrive: false,
	email: false,
	unlayerEmail: false,
	askAi: false,
	automation: false,
	share: false,
	clientDialog: false,
	relationshipContact: false,
	relationshipCompany: false,
	editContact: false,
	selectFiles: false,
	lossReason: false,
	userProfile: false,
	brokerageProfile: false,
	issueReporting: false,
	recordInformedConsent: false,
	informedConsentHistory: false,
};

export const dialogSlice = createSlice({
	name: 'dialog',
	initialState: {
		open: {
			...dialogState,
		},
		data: {
			...Object.keys(dialogState).reduce(
				(acc, key) => ({
					...acc,
					[key]: {},
				}),
				{},
			),
		},
	},
	reducers: {
		openDialog: (state, action) => {
			const dialogName =
				typeof action.payload === 'string' ? action.payload : action.payload.dialogName;
			const data = action.payload.data ?? {};
			state.open[dialogName] = true;
			state.data[dialogName] = data;
		},
		closeDialog: (state, action) => {
			state.open[action.payload] = false;
			state.data[action.payload] = {};
		},
		setDialogData: (state, action) => {
			const dialogName =
				typeof action.payload === 'string' ? action.payload : action.payload.dialogName;
			const data = action.payload.data ?? {};
			if (state.open[dialogName]) {
				state.data[dialogName] = data;
			} else {
				state.data[dialogName] = {};
			}
		},
	},
});

export const { openDialog, closeDialog, setDialogData } = dialogSlice.actions;
export default dialogSlice.reducer;
